import React from 'react';
import { DisabledTag } from '@nile/mangifera/src/Pebbles/TicketContainer';
import { Badge } from '@superops/ui-design-system';
import StatusBadge from '../../../../asset-management/components/sub-pages/all-monitored-assets-view/StatusBadge';

function AssetStatusCell(props) {
  const { cell } = props;
  return (
    // eslint-disable-next-line react/jsx-filename-extension
    <>
      <div className="ellipsis">
        {cell.value ? (
          <div className="uppercase">
            <StatusBadge statusValue={cell?.value} />
          </div>
        ) : (
          <DisabledTag>NA</DisabledTag>
        )}
      </div>
    </>
  );
}

export default AssetStatusCell;
